/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { GetAllFoerderprogrammeQuery as AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeQuery } from '../models/ace/xFound/Portal/Core/CAQ/Foerderprogramm/Queries/get-all-foerderprogramme-query';
import { GetAllFoerderprogrammeResponse as AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse } from '../models/ace/xFound/Portal/Core/CAQ/Foerderprogramm/Queries/get-all-foerderprogramme-response';

@Injectable({
providedIn: 'root',
})

export class FoerderprogrammService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiFoerderprogrammGet
   */
  static readonly ApiFoerderprogrammGetPath = '/api/Foerderprogramm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoerderprogrammGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoerderprogrammGet$Plain$Response(params?: {
    query?: AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FoerderprogrammService.ApiFoerderprogrammGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiFoerderprogrammGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoerderprogrammGet$Plain(params?: {
    query?: AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeQuery;
  }): Observable<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse> {

    return this.apiFoerderprogrammGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>) => r.body as AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoerderprogrammGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoerderprogrammGet$Response(params?: {
    query?: AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, FoerderprogrammService.ApiFoerderprogrammGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiFoerderprogrammGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoerderprogrammGet(params?: {
    query?: AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeQuery;
  }): Observable<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse> {

    return this.apiFoerderprogrammGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse>) => r.body as AceXFoundPortalCoreCaqFoerderprogrammQueriesGetAllFoerderprogrammeResponse)
    );
  }

}